var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-home home" }, [
    _c(
      "div",
      { staticClass: "header-logo small-20  align-center" },
      [_c("c-logo")],
      1
    ),
    _vm._v(" "),
    _vm.product && _vm.isValidProduct(_vm.product)
      ? _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row v-center" }, [
            _c("div", { staticClass: "std-content intro" }, [
              _vm.product.name
                ? _c("div", { staticClass: "name small-10 align-center" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.product.name))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.description
                ? _c(
                    "div",
                    { staticClass: "description align-center small-20" },
                    [_c("h2", [_vm._v(_vm._s(_vm.product.description))])]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.product.images.material
              ? _c(
                  "div",
                  {
                    staticClass: "std-content-image--full align-center small-20"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: this.getSbkImage(
                          _vm.product.images.material,
                          "500x500"
                        )
                      }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.coordsReady
            ? _c("div", { staticClass: "row" }, [
                2 === 2
                  ? _c(
                      "div",
                      { staticClass: "map align-center small-20" },
                      [
                        _c("c-gmap", {
                          attrs: { locations: _vm.getValidLocations() }
                        }),
                        _vm._v(" "),
                        _c("c-map-key", { attrs: { locations: _vm.locations } })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.product.provenanceJourney.length > 0
                  ? _c(
                      "div",
                      { staticClass: "provenance align-center small-20" },
                      [
                        _c("h2", [_vm._v("Provenance Journey")]),
                        _vm._v(" "),
                        _vm._l(_vm.product.provenanceJourney, function(
                          step,
                          idx
                        ) {
                          return step.trim().length > 0
                            ? _c("p", { key: idx, staticClass: "step" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(step) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "std-content-image--right" }, [
              _vm.product.images.animalWelfare
                ? _c("img", {
                    staticClass: "small-20",
                    attrs: {
                      src: this.getSbkImage(
                        _vm.product.images.animalWelfare,
                        "500x500"
                      )
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.product.animalWelfare
              ? _c(
                  "div",
                  { staticClass: "std-content align-center small-20" },
                  [
                    _c("h2", [_vm._v("Animal Welfare")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.product.animalWelfare) +
                          "\n              "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm.product.whoMadeYourClothes
              ? _c("div", { staticClass: "std-content-image--left" }, [
                  _vm.product.images.whoMadeYourClothes
                    ? _c("img", {
                        attrs: {
                          src: this.getSbkImage(
                            _vm.product.images.whoMadeYourClothes,
                            "500x500"
                          )
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.product.whoMadeYourClothes
              ? _c("div", { staticClass: "std-content align-center" }, [
                  _c("h2", [_vm._v("Who Made Your Clothes")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.product.whoMadeYourClothes) +
                        "\n              "
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "std-content-image--right" }, [
              _vm.product.images.environmentalWelfare
                ? _c("img", {
                    attrs: {
                      src: this.getSbkImage(
                        _vm.product.images.environmentalWelfare,
                        "500x500"
                      )
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.product.environmentalWelfare.length > 0
              ? _c(
                  "div",
                  { staticClass: "std-content align-center small-20" },
                  [
                    _c("h2", [_vm._v("Environmental Welfare")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.product.environmentalWelfare) +
                          "\n              "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm.product.whyItMatters.length > 0
              ? _c(
                  "div",
                  { staticClass: "std-content align-center small-20" },
                  [
                    _c("h2", { staticClass: "indent" }, [
                      _vm._v("Why it Matters")
                    ]),
                    _vm._v(" "),
                    _c(
                      "ol",
                      { staticClass: "stats" },
                      _vm._l(_vm.product.whyItMatters, function(item, idx) {
                        return _c("li", { key: idx, staticClass: "stat" }, [
                          _c("p", [_vm._v(_vm._s(item))])
                        ])
                      }),
                      0
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "comment-form align-center small-20" },
              [
                _c("h2", [_vm._v("Comment")]),
                _vm._v(" "),
                _c("p", [_vm._v("We would love to hear from you")]),
                _vm._v(" "),
                _c("c-comments-form")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "share align-center small-20" }, [
              _c("h2", [_vm._v("Share")]),
              _vm._v("\n            Feel free to share\n\n              "),
              _c("ul", { staticClass: "c-SocialLinks" }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "c-SocialLink",
                      attrs: { href: _vm.socialShare.twitter, target: "_blank" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "//a.storyblok.com/f/56947/x/162628eca0/twitter.svg",
                          alt: "Find us on Twitter"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "c-SocialLink",
                      attrs: {
                        href: _vm.socialShare.facebook,
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "//a.storyblok.com/f/56947/x/44690efad4/facebook.svg",
                          alt: "Find us on Facebook"
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer-logo small-20  align-center" }, [
            _c(
              "a",
              {
                staticClass: "c-SocialLink",
                attrs: { href: "http://google.com", target: "_blank" }
              },
              [_c("c-logo")],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-copyright small-20  align-center" },
            [
              _vm._v(
                "\n            © Copyright Another Tomorrow 2019\n          "
              )
            ]
          )
        ])
      : _vm.error
      ? _c("div", { staticClass: "error" }, [
          _vm._v("\n          error\n        ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }